// extracted by mini-css-extract-plugin
export default {"root":"_1uwtQmqU","header":"_3PnVmsFA","title":"_3NR09vXe","icon":"_3AHPyKVT","iconBtn":"_3DEC1Lzz"};